import React from 'react'
import '../styles/tailwind.css'
import LegalPage, { Callout, List, Section } from '../components/LegalPage'

const KebijakanPrivasi = () => (
  <LegalPage title="Kebijakan Privasi" updatedAt="2 September 2026">
    <p className="mb-8 text-sm leading-relaxed text-[#53565D]">
      Kebijakan ini menjelaskan bagaimana data pribadi diperlakukan di dalam
      sistem administrasi keanggotaan The Jakmania, serta apa yang menjadi
      tanggung jawab Anda sebagai pengguna yang memiliki akses ke data
      tersebut.
    </p>

    <Section number="1" title="Dasar Hukum">
      <p>
        Pengelolaan data pribadi dalam sistem ini tunduk pada Undang-Undang
        Nomor 27 Tahun 2022 tentang Perlindungan Data Pribadi, yang selanjutnya
        disebut UU PDP, beserta peraturan pelaksananya.
      </p>
      <p>
        Dalam kerangka UU PDP, organisasi bertindak sebagai Pengendali Data
        Pribadi. Pengurus dan korwil yang memiliki akses bertindak untuk dan
        atas nama Pengendali, sehingga terikat pada kewajiban yang sama.
      </p>
    </Section>

    <Section number="2" title="Data yang Diproses">
      <p>Data pendaftar dan anggota yang diproses meliputi:</p>
      <List
        items={[
          'Identitas: nama lengkap, Nomor Induk Kependudukan, tanggal lahir, dan jenis pendaftaran.',
          'Kontak: alamat surel, nomor telepon, dan alamat tempat tinggal sampai tingkat kelurahan.',
          'Dokumen: foto kartu tanda penduduk, pas foto, dan berkas pendukung lain yang diunggah saat pendaftaran.',
          'Keanggotaan: nomor registrasi, nomor kartu tanda anggota, korwil, status verifikasi, dan masa berlaku.',
        ]}
      />
      <p>
        Untuk pengguna sistem, data yang diproses meliputi alamat surel, peran,
        dan catatan aktivitas selama menggunakan sistem.
      </p>
    </Section>

    <Section number="3" title="Tujuan Pemrosesan">
      <List
        items={[
          'Memverifikasi keabsahan pendaftaran dan mencegah pendaftaran ganda.',
          'Menerbitkan serta memperpanjang kartu tanda anggota.',
          'Menyusun rekapitulasi keanggotaan untuk keperluan organisasi.',
          'Menghubungi anggota terkait status keanggotaannya.',
        ]}
      />
      <p>
        Data tidak diproses untuk tujuan lain di luar daftar tersebut tanpa
        dasar hukum yang sah atau persetujuan baru dari pemilik data.
      </p>
    </Section>

    <Section number="4" title="Kewajiban Anda sebagai Pemegang Akses">
      <List
        items={[
          'Terapkan prinsip seperlunya. Buka dan proses data hanya sebatas yang dibutuhkan untuk menyelesaikan tugas Anda saat itu.',
          'Jangan menyimpan salinan data di perangkat pribadi, penyimpanan awan pribadi, atau aplikasi perpesanan.',
          'Hasil ekspor berkas CSV berisi data pribadi. Perlakukan berkas tersebut sebagai dokumen rahasia dan hapus setelah selesai digunakan.',
          'Jangan membagikan tangkapan layar yang memuat Nomor Induk Kependudukan, alamat, atau nomor telepon anggota.',
          'Pastikan perangkat yang Anda pakai terkunci dengan kata sandi dan tidak dipakai bersama orang lain.',
        ]}
      />
    </Section>

    <Callout title="Kewajiban khusus berdasarkan UU PDP">
      <p>
        Nomor Induk Kependudukan dan dokumen identitas termasuk data yang
        memerlukan perlindungan lebih tinggi. Pemrosesan yang melampaui tujuan
        keanggotaan berpotensi melanggar UU PDP.
      </p>
      <p>
        Apabila terjadi kegagalan pelindungan data pribadi, misalnya data
        bocor, hilang, atau diakses pihak tidak berwenang, UU PDP mewajibkan
        pemberitahuan tertulis kepada pemilik data dan kepada lembaga
        berwenang paling lambat tiga kali dua puluh empat jam sejak diketahui.
        Karena itu, setiap dugaan insiden wajib Anda laporkan kepada pengurus
        pusat pada kesempatan pertama, sekalipun Anda belum yakin data
        benar-benar terekspos.
      </p>
    </Callout>

    <Section number="5" title="Penyimpanan dan Keamanan">
      <p>
        Data disimpan pada infrastruktur yang dikelola organisasi. Akses
        dibatasi berdasarkan peran, sehingga korwil hanya dapat melihat data
        wilayah yang menjadi tanggung jawabnya. Dokumen identitas disimpan
        terpisah dan hanya dapat dibuka melalui tautan sementara yang berlaku
        singkat.
      </p>
    </Section>

    <Section number="6" title="Pembagian Data">
      <p>
        Data anggota tidak diperjualbelikan dan tidak dibagikan kepada pihak
        ketiga, kecuali kepada penyedia layanan teknis yang mendukung
        operasional sistem, atau apabila diwajibkan oleh peraturan
        perundang-undangan dan permintaan resmi aparat penegak hukum.
      </p>
    </Section>

    <Section number="7" title="Hak Pemilik Data">
      <p>
        Berdasarkan UU PDP, pemilik data pribadi berhak untuk mendapatkan
        informasi mengenai penggunaan datanya, mengakses dan memperoleh
        salinannya, meminta pembetulan data yang keliru, meminta penghapusan,
        menarik persetujuan, serta mengajukan keberatan atas pemrosesan
        tertentu.
      </p>
      <p>
        Permintaan semacam ini wajib diteruskan kepada pengurus pusat dan tidak
        boleh Anda tangani sendiri, agar penanganannya tercatat dan sesuai
        ketentuan.
      </p>
    </Section>

    <Section number="8" title="Masa Retensi">
      <p>
        Data keanggotaan disimpan selama status keanggotaan masih aktif dan
        selama masih dibutuhkan untuk keperluan administrasi organisasi atau
        sepanjang diwajibkan peraturan perundang-undangan. Setelah itu data
        dihapus atau dianonimkan.
      </p>
    </Section>

    <Section number="9" title="Kontak">
      <p>
        Pertanyaan, permintaan dari pemilik data, atau laporan dugaan insiden
        keamanan dapat disampaikan kepada pengurus pusat The Jakmania melalui
        kanal resmi organisasi.
      </p>
    </Section>
  </LegalPage>
)

export default KebijakanPrivasi
